var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"name":_vm.name}},[_vm._v("Click the button below to onboard your VP Sim device.")])}
var staticRenderFns = []

export { render, staticRenderFns }